export default {
    'new-administrative-requests': 'New administrative requests',
    'leave-requests': 'Leave requests',
    'administrative-day': 'Administrative day',
    'modification-requests': 'Modification requests',
    'modification': 'Modification',
    'addition': 'Addition',
    'deletion': 'Deletion',
    'office-visits-yesterday': 'Office visits yesterday'
}